import { Component } from "@angular/core";
import { DynamicDialogRef } from "primeng/dynamicdialog";
@Component({
	selector: "app-system-message",
	templateUrl: "./system-message.component.html",
	styleUrls: ["./system-message.component.scss"],
})
export class SystemMessageComponent {
	constructor(private ref: DynamicDialogRef) {}
	close() {
		this.ref.close();
	}
}
